import { render, staticRenderFns } from "./RedeemCoinManagementScreen.vue?vue&type=template&id=58408f10&scoped=true&"
import script from "./RedeemCoinManagementScreen.vue?vue&type=script&lang=js&"
export * from "./RedeemCoinManagementScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58408f10",
  null
  
)

export default component.exports